import { LoadingAnimation } from '@backrs_ui/grow-ui/src/pages/OfficeHours/molecules/LoadingAnimation';

import { Box, SxProps, Theme } from '@mui/material';

import { CUSTOM_TABS } from './customTabs';
import { InfoBoxContent } from './InfoBoxContent';
import { type UseShellResourceTabsReturn } from './useShellResourceTabs';
import { SessionBanner } from '../SessionBanner';

type ShellResourceContentProps = Readonly<{
  resourceTabs: UseShellResourceTabsReturn;
}>;

export const ShellResourceContent = ({ resourceTabs }: ShellResourceContentProps) => {
  const {
    showResourceContent,
    isContentReady,
    isLoadingExistingOutput,
    selectedCustomTabId,
    contentProps,
  } = resourceTabs;

  if (selectedCustomTabId) {
    const { Component } = CUSTOM_TABS[selectedCustomTabId];

    return (
      <Box sx={contentContainerSx}>
        <Component />
      </Box>
    );
  }

  if (showResourceContent) {
    const showOutputSkeleton = isLoadingExistingOutput && contentProps.isFeaturedTab;

    return (
      <Box sx={contentContainerSx}>
        {contentProps.isFeaturedTab && <SessionBanner />}
        {showOutputSkeleton || isContentReady ? (
          <InfoBoxContent {...contentProps} isLoading={showOutputSkeleton} />
        ) : (
          <LoadingAnimation />
        )}
      </Box>
    );
  }

  return null;
};

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  height: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: backrs.spacing['spacing-2xl'],
});
